import { useSearchParams } from 'react-router-dom';
import { updateSearchParams } from 'components/Router/searchParams';
import Toggle, { ToggleAttributes, ToggleProps } from '@ingka/toggle';
import classes from './OMFilters.module.scss';

interface SortOrderParam {
    [key: string]: string;
}

const OMFilterSort = ({
    toggleLabels,
    param,
    ...toggleProps
} : {
    toggleLabels: (ToggleProps & ToggleAttributes)['buttons'],
    param: string,
} & Omit<ToggleProps & ToggleAttributes, 'buttons' | 'className' | 'onClick'>) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const sortOrder = searchParams.get(param) ?? '0';

    return (
        <Toggle
            className={classes['om-filters-toggle-button']}
            buttons={toggleLabels}
            activeIndex={Number(sortOrder) ?? undefined}
            onClick={(_, index) => {
                if (Number(sortOrder) !== index) {
                    const sortOrderParam: SortOrderParam = {};
                    sortOrderParam[param] = index.toString();
                    updateSearchParams([sortOrderParam], searchParams, setSearchParams);
                }
            }}
            {...toggleProps}
        />
    );
};

export default OMFilterSort;
